import { inject, Injectable } from "@angular/core";
import { BaseWorkflowStateService } from "../base-workflow-state.service";
import { WirelessFlowStateService } from "./wireless-flow-state.service";
import { LineConfigurationState, SingleLineConfiguration } from "../../../../../../models/line-configurations.model";
import { WirelessProductPlusResponseService } from "../../order-api-response/wireless-pd-plus-response.service";
import { WirelessPDPlusLine } from "../../../../../../models/order/api-models/order-pd-plus-response.model";

@Injectable({ providedIn: 'root' })
export class WirelessLineConfigurationStateService extends BaseWorkflowStateService<LineConfigurationState> {
    private flowStateService = inject(WirelessFlowStateService);
    private wirelessProductPlusResponseService = inject(WirelessProductPlusResponseService);
    override stateKey: string = 'lineConfigurations';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ lineConfigurations: this.state() });
    }

    getLineConfiguration(lineNumber: number): SingleLineConfiguration | undefined {
        return this.state() ? this.state()['line' + lineNumber] : undefined;
    }

    getLatestWirelessLine(lineNumber: number): WirelessPDPlusLine | null {
        const latestCallLine = this.flowStateService.state()?.latestPdPlusCallHappenedOnLine;
        return this.wirelessProductPlusResponseService.findWirelessLine(latestCallLine, lineNumber)
            ?? this.wirelessProductPlusResponseService.findWirelessLine(lineNumber, lineNumber);
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}